const SHAREHOLDER_TYPE = {
  DIRECT: 'DIRECT',
  INDIRECT: 'INDIRECT',
  CONTROLLER: 'CONTROLLER',
} as const;

const SHAREHOLDER_PERSON_TYPE = {
  LEGAL: 'legal',
  NATURAL: 'natural',
} as const;

const SHAREHOLDER_PERSON_TYPE_OPTIONS = [
  { title: 'Natural', value: SHAREHOLDER_PERSON_TYPE.NATURAL },
  { title: 'Jurídica', value: SHAREHOLDER_PERSON_TYPE.LEGAL },
] as const;

const SHAREHOLDER_PARTICIPATION_TYPE_OPTIONS = [
  { title: 'Directa', value: SHAREHOLDER_TYPE.DIRECT },
  { title: 'Indirecta', value: SHAREHOLDER_TYPE.INDIRECT },
  { title: 'Controlador', value: SHAREHOLDER_TYPE.CONTROLLER },
] as const;

const SHAREHOLDER_PARTICIPATION_THRESHOLDS = Object.freeze({
  CO: 5,
  DEFAULT: 10,
} as const);

const COLOMBIA_COUNTRY_CODE = 'CO';

export {
  SHAREHOLDER_TYPE,
  SHAREHOLDER_PERSON_TYPE,
  SHAREHOLDER_PERSON_TYPE_OPTIONS,
  SHAREHOLDER_PARTICIPATION_TYPE_OPTIONS,
  SHAREHOLDER_PARTICIPATION_THRESHOLDS,
  COLOMBIA_COUNTRY_CODE,
};
